import { useId, useRef } from "react";
import { InputWithLabelWrapper, TicketInfoLabel, StyledInput } from "../TicketInfoField/TicketInfoField.styled";
import { formatDate } from 'src/utils/dateFns/formatDate';
import { getTimeAM_PM } from 'src/utils/dateFns/formatTime';

interface CreatedOnProps {
    date: string;
}

export const CreatedOnField = ({date}: CreatedOnProps) => {
    const inputId = useId();
    const inputRef = useRef<HTMLInputElement>();
    const { month, day, year } = formatDate(new Date(date));
    const { hour, minutes, am_pm } = getTimeAM_PM(new Date(date));

    const handleFocus = () => {
        if(inputRef.current)
        {
            inputRef.current?.blur();
        }
    }

    return (
        <InputWithLabelWrapper>
            <TicketInfoLabel htmlFor={inputId} size="medium">Created date</TicketInfoLabel>
            <StyledInput 
                appearance="outline"
                size="medium"
                readOnly
                value={`${month}/${day}/${year} at ${hour}:${minutes} ${am_pm}`}
                id={inputId}
                ref={inputRef}
                onFocus={handleFocus} />
        </InputWithLabelWrapper>
    );
}